/**
 * Trip Kit category colours, sourced from Trip Kit 3.0 in Figma
 * (file HMuxdBvOE4IW1JtBer8yRj, node 4915-10298).
 *
 * These deliberately are not LuxKit semantic tokens. The rebrand palette has no
 * per-category ramp, and borrowing messaging/highlight tokens for categories is
 * exactly what produced the wrong colours these replace. Background values carry
 * their own alpha so the chips tint whichever surface they sit on.
 */
export const TRIP_LIST_CATEGORY_COLOUR_GROUPS = [
  'hotel',
  'food-and-drink',
  'active-and-outdoor',
  'shopping',
  'entertainment-and-leisure',
  'transport',
] as const

export type TripListCategoryColourGroup = typeof TRIP_LIST_CATEGORY_COLOUR_GROUPS[number]

export interface TripListCategoryColours {
  foreground: string
  background: string
}

export const TRIP_LIST_CATEGORY_COLOURS: Record<TripListCategoryColourGroup, TripListCategoryColours> = {
  hotel: { foreground: '#4E0493', background: '#9B51E026' },
  'food-and-drink': { foreground: '#964400', background: '#CC6F1F26' },
  'active-and-outdoor': { foreground: '#006E1F', background: '#00A9471A' },
  shopping: { foreground: '#A40031', background: '#EB5B8C1A' },
  'entertainment-and-leisure': { foreground: '#0A6A75', background: '#17A2B826' },
  transport: { foreground: '#00337F', background: '#00398E1A' },
}
